import { gql } from '@apollo/client';
import { ACFMediaFragment } from './ACF/Media';
import { PageDataFragment } from './PageData';

export const FeaturedInducteesFragment = gql`
  ${ACFMediaFragment} 
  ${PageDataFragment}
  fragment FeaturedInductees on AcfContentNodeConnection {
    nodes {
      ... on Inductee {
        title
        uri
        ...PageData
        inducteeData {
          category
          inducteeClass {
            slug
          }
        }
      }
    }
  }
`;